import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=18a8e85c&"
import script from "./factory.vue?vue&type=script&lang=ts&"
export * from "./factory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "factory.vue"
export default component.exports